"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPaperEndAdornment = exports.StyledPaperFooterAlert = exports.StyledPaperActions = exports.StyledPaperTitle = exports.StyledPaperTitleWrapper = exports.StyledDefaultPaper = void 0;
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const styled_components_1 = __importStar(require("styled-components"));
const animation_1 = require("../animation");
const flexbox_1 = require("../flexbox");
exports.StyledDefaultPaper = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  ${({ noRound, noShadow, noBg, isBlurred, fadeIn, customStyles, bgColor, withHover, noPadding, minimal, }) => {
    return (0, styled_components_1.css) `
      padding-inline: ${noPadding ? '0 !important' : theme_1.paddings.card.desktop.inline};
      padding-block: ${noPadding ? '0 !important' : theme_1.paddings.card.desktop.block};
      border-radius: ${noRound || minimal ? 0 : theme_1.borders.radius.card};
      box-shadow: ${isBlurred
        ? theme_1.defaultTheme.shadows.blurred
        : noShadow || minimal
            ? 'unset'
            : theme_1.defaultTheme.shadows.default(theme_1.grayScale[900])};
      background-color: ${noBg || minimal ? 'transparent' : bgColor !== null && bgColor !== void 0 ? bgColor : theme_1.palette.grayScale[50]};
      pointer-events: ${isBlurred ? 'none' : 'all'};
      transition: all 0.3s ease-in-out;
      animation: ${fadeIn
        ? (0, styled_components_1.css) `
              ${animation_1.fadeInAnimation} 0.5s linear
            `
        : 'none'};
      filter: ${isBlurred ? 'blur(5px)' : 'none'};
      ${withHover &&
        (0, styled_components_1.css) `
          cursor: pointer;
          &:hover {
            box-shadow: ${theme_1.defaultTheme.shadows.hover};
          }
        `}
      
        }
      @media (max-width: ${theme_1.defaultTheme.gridSystem.vpBreakpoints.VPL - 1}px) {
        padding-inline: ${noPadding ? '0 !important' : theme_1.paddings.card.mobile.inline};
        padding-block: ${noPadding ? '0 !important' : theme_1.paddings.card.mobile.block};
      }
      ${customStyles || {}};
    `;
}}
`;
exports.StyledPaperTitleWrapper = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  border-bottom: ${`1px solid ${theme_1.palette.grayScale[100]}`};
  padding: ${({ noPadding }) => noPadding ? '0' : theme_1.paddings.cardTitle};
  ${({ cardTitleProps }) => (cardTitleProps === null || cardTitleProps === void 0 ? void 0 : cardTitleProps.customStyles) || {}}
`;
exports.StyledPaperTitle = styled_components_1.default.h4 `
  font-weight: ${theme_1.fonts.heading.h1.fontWeight};
  font-size: ${theme_1.fonts.heading.h1.fontSize};
  line-height: ${theme_1.fonts.heading.h1.lineHeight};
  text-align: left;
`;
exports.StyledPaperActions = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  padding: ${theme_1.spacings.s9};
  gap: ${theme_1.spacings.s7};
`;
exports.StyledPaperFooterAlert = styled_components_1.default.div `
  ${({ alertProps }) => {
    const variant = (alertProps === null || alertProps === void 0 ? void 0 : alertProps.variant) || 'success';
    return (0, styled_components_1.css) `
      background-color: ${theme_1.palette.system[variant]};
      font-size: ${theme_1.fonts.body.small.fontSize};
      color: ${['error', 'success'].includes(variant)
        ? theme_1.palette.grayScale[50]
        : theme_1.palette.grayScale[900]};
      width: 100%;
      padding: ${`${(0, utils_1.pxToRem)(10)} ${theme_1.spacings.s5}`};
      font-size: ${theme_1.spacings.s3};
      text-align: left;
      border-radius: ${`0 0 ${theme_1.borders.radius.card} ${theme_1.borders.radius.card}`};
    `;
}}
`;
exports.StyledPaperEndAdornment = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  padding: ${`${(0, utils_1.pxToRem)(10)} ${theme_1.spacings.s5}`};
`;
//# sourceMappingURL=styles.js.map